var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
};


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.nav = {
	init: function() {
		// Add expand link to mobile menu
		$('.children', '#mainmenu ').prepend('<span class="expand"><i class="fa fa-angle-down"></span>');
		$('.selectedLevel1','#mainmenu').addClass('down');
		$('.selectedLevel2','#mainmenu').addClass('down');
		$('.selectedLevel3','#mainmenu').addClass('down');
		$('.selectedLevel4','#mainmenu').addClass('down');
		site.nav.bind();
	},
	bind: function() {
		// Mobile menu toggle
		$('#mainmenuToggle').click(function(e) {
			e.stopPropagation();
			e.preventDefault();

			var menuOpen = $('body').hasClass('mainmenu-open');
			site.nav.mobileToggle(e, menuOpen);

			$('#mainmenu').on('click', function(e) {
				e.stopPropagation();
			});

			$('body.mainmenu-open').on('click', function (e) {
				$('body').removeClass('mainmenu-open');
			});
		});

		// Expand in mobile menu
		$('.expand', '#mainmenu').bind('click', function(e) {
			e.preventDefault();
			$(this).closest('li').toggleClass('down');
		});
	},
	// Toggle mobile menu
	mobileToggle: function(e, menuOpen) {
		$('body').toggleClass('mainmenu-open');
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});
	site.nav.init();

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="margin-left: 20px;float:right; max-width:'+$(this).width()+'px"><div style="height:'+$(this).height()+'px; width:'+$(this).width()+'px;" class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$('body').is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}
	if($('body').is('.frontpage')) {
		site.owl.init('#owl-front1', {
			items:1,
			loop:true,
			dots:false,
			navigation:false,
			autoplay:true,
			autoplayTimeout:6000,
			audotplaySpeed:500,
			animateOut: 'fadeOut',
			animateIn: 'fadeIn'
		});

		$('.bannerDown').click(function(e) {
			e.preventDefault();
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
			documentWidth = $(document).width() -15;
			if (documentWidth >= 991) {
				$('html,body').animate({scrollTop: target.offset().top}, 'slow');
			}
			else {
				$('html,body').animate({scrollTop: target.offset().top - 70}, 'slow');
			}
		});
	}

	// Touch login
	$('.login').dblclick(function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	site.owl.init('.categoriesLevel2Wrapper', {
		items: 1,
		mouseDrag: false,
		animateIn: 'fadeInDownShort',
		margin:30,
		autoHeight : true
	});

	var customNav = [];
	$('.categoriesLevel2Wrapper').each(function() {
		$wrapper = $(this);
		$nav = $('<div class="custom-owl-nav"></div>');

		$wrapper.find('h3').each(function() {
			var anchorLink = '#'+$(this).closest('.category').attr('class').split(' ')[1];
			$('<div class="link"><a href="'+anchorLink+'">' + $(this).addClass('sr-only').text() + '</a></div><div class="spacer"></div>').appendTo($nav);
			customNav.push(anchorLink);
		});

		$nav.find('.spacer').last().remove();

		$('.link', $nav).first().addClass('active');
		$nav.insertBefore($wrapper);

		// Update header
		$wrapper.on('changed.owl.carousel', function(event) {
			$nav = $(this).siblings('.custom-owl-nav');
			$activeLink = $($nav.children('.link').get(event.item.index));
			$activeLink.siblings().removeClass('active');
			$activeLink.addClass('active');
			// TODO: Scroll to active tab?
		});
	});

	$('.categoriesLevel2Wrapper .categoryLevel2').each(function() {
		$this = $(this);
		height = $this.height();
		$album = $this.find('.album');
		if($album) {
			$album.height(height);
		}
	});

	$('.custom-owl-nav .link').on('click', function(e) {
		e.preventDefault();
		$this = $(this);
		$(this).parent().siblings('.owl-carousel').trigger('to.owl.carousel', $this.index() - $this.prevAll('.spacer').length);
		$this.addClass('active').siblings().removeClass('active');
		window.location.hash = $this.find('a').attr('href');
	});

	var hashed = null;
	hashed = location.hash;
	$('#mainmenu a').on('click',function(e) {
		if(this.hash) {
			hashed = this.hash;
			if(hashed) {
				if(jQuery.inArray(hashed, customNav) !== -1) {
					var target = $('.custom-owl-nav .link a[href="'+hashed+'"]');
					target.parent().trigger('click');
					//$('html,body').animate({scrollTop: target.offset().top - 38}, 'slow');
					//$('#mainmenu .selectedLevel1').removeClass('selectedLevel1');
					//$(this).parent().addClass('selectedLevel1');
				}
			}
		}
	});
	if(hashed) {
		if(jQuery.inArray(hashed, customNav) !== -1) {
			var target = $('.custom-owl-nav .link a[href="'+hashed+'"]');
			target.parent().trigger('click');
			//$('html,body').animate({scrollTop: target.offset().top - 38}, 'slow');
		}
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
